













































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Evaluation from '@/evaluations/entities/evaluation'
import EvaluationFilter from '@/evaluations/entities/evaluation-filter'
import { EvaluationStatus } from '@/evaluations/entities/evaluation-status'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import evaluationService from '@/evaluations/services/evaluation-service'
import isEqual from 'lodash/isEqual'
import bus from '@/app/bus'
import CloneDialog from '@/evaluations/components/clone-dialog.vue'

@Component
export default class Evaluations extends Vue {
  private loading = false

  private draftFilter = new EvaluationFilter()
  private inProgressFilter = new EvaluationFilter()
  private finishedFilter = new EvaluationFilter()

  private showClone = false

  private draftEvaluations: Evaluation[] = []
  private inProgressEvaluations: Evaluation[] = []
  private finishedEvaluations: Evaluation[] = []

  @Ref()
  private cloneDialog!: CloneDialog

  @Watch('draftFilter.paging')
  private async draftFilterPagingChanged(
    val: PaginationRequest,
    old: PaginationRequest
  ) {
    if (isEqual(val, old) === false) {
      await this.fetchAllDrafts()
    }
  }

  @Watch('inProgressFilter.paging')
  private async inProgressFilterPagingChanged(
    val: PaginationRequest,
    old: PaginationRequest
  ) {
    if (isEqual(val, old) === false) {
      await this.fetchAllInProgress()
    }
  }

  @Watch('finishedFilter.paging')
  private async finishedFilterPagingChanged(
    val: PaginationRequest,
    old: PaginationRequest
  ) {
    if (isEqual(val, old) === false) {
      await this.fetchAllFinished()
    }
  }

  private async fetchAllDrafts(resetPage = false) {
    this.loading = true
    if (resetPage) {
      this.draftFilter.paging.page = 1
    }
    const response = await evaluationService.findAllPagedAsync(this.draftFilter)
    this.draftEvaluations = response.items
    this.draftFilter.paging.totalItems = response.totalItems
    this.loading = false
  }

  private async fetchAllInProgress(resetPage = false) {
    this.loading = true
    if (resetPage) {
      this.inProgressFilter.paging.page = 1
    }
    const response = await evaluationService.findAllPagedAsync(
      this.inProgressFilter
    )
    this.inProgressEvaluations = response.items
    this.inProgressFilter.paging.totalItems = response.totalItems
    this.loading = false
  }

  private async fetchAllFinished(resetPage = false) {
    this.loading = true
    if (resetPage) {
      this.finishedFilter.paging.page = 1
    }
    const response = await evaluationService.findAllPagedAsync(
      this.finishedFilter
    )
    this.finishedEvaluations = response.items
    this.finishedFilter.paging.totalItems = response.totalItems
    this.loading = false
  }

  private create() {
    this.$router.push({
      name: 'evaluationcreate',
      params: {
        lang: this.$i18n.locale,
      },
    })
  }

  private edit(evaluation: Evaluation) {
    this.$router.push({
      name: 'evaluationedit',
      params: {
        lang: this.$i18n.locale,
        id: evaluation.id,
      },
    })
  }

  private async clone(evaluation: Evaluation) {
    this.cloneDialog.open(evaluation.id)
  }

  private async cloneEvaluation(cloneOption: string, evaluationId: string) {
    if (cloneOption === '1') {
      await evaluationService.cloneWithCandidatesAsync(evaluationId)
    } else {
      await evaluationService.cloneAsync(evaluationId)
    }

    await this.fetchAllDrafts()
    await this.fetchAllInProgress()
    await this.fetchAllFinished()
  }

  private details(evaluation: Evaluation) {
    this.$router.push({
      name: 'evaluationdetails',
      params: {
        lang: this.$i18n.locale,
        id: evaluation.id,
      },
    })
  }

  private showInfo() {
    bus.$emit(
      'app.help-dialog.show',
      `
    <h2 name="terms">Begriffe</h2>
<br/>
<dl>
  <dt><strong>Evaluierung</strong></dt>
  <dd>
    Fasst sämtliche Informationen zu einem Evaluierungsvorgang zusammen und
    besteht aus Titel, Beschreibung, Firmenname, Expert:in, Notizen,
    Kompetenzen, Assessoren und Kandidat:innen
  </dd>
  <dt><strong>Expert:in</strong></dt>
  <dd>
    Ist ein Benutzer des Systems der die Berechtigung hat, eine Evaluierung zu
    starten und zu stoppen.
  </dd>
  <dt><strong>Assessor</strong></dt>
  <dd>
    Der Assessor bewertet Kandidat:innen über einen Link, der per E-Mail
    zugesendet wird.
  </dd>
  <dt><strong>Kompetenz</strong></dt>
  <dd>
    Eine Kompetenz ist eine Fähigkeit, nach der ein(e) Kandidat:in beurteilt
    wird. Sie besteht aus der Bezeichnung, einer näheren Beschreibung sowie
    einer Liste an Fragen, die bei der Beurteilung, ob ein(e) Kandidat:in diese
    Kompetenz erfüllt, helfen soll.
  </dd>
</dl>
<br/>
<h2 name="home">Übersicht der Evaluierungen</h2>
<br/>
<p>
  Auf dieser Seite sehen Sie eine Übersicht über alle Evaluierungen, die aktuell
  im System gespeichert sind.
</p>

<p>
  <strong>Evaluierungsentwürfe</strong> sind Evaluierungen, die nicht fertig
  aufgesetzt und noch nicht für die Beurteilung durch
</p>

<p>
  <strong>Laufende Evaluierungen</strong> sind Evaluierungen, die aktuell für
  die Bearbeitung freigegeben sind. Assessoren können bei diesen Evaluierungen
  die Kandidaten bewerten.
</p>

<p>
  <strong>Abgeschlossene Evaluierungen</strong> sind Evaluierungen, die vom
  Experten oder Expertin beendet wurden. Assessoren können hier keine Bewertungen mehr
  vornehmen.
</p>
    `
    )
  }

  private async remove(evaluation: Evaluation) {
    await evaluationService.removeAsync(evaluation)
    await this.fetchAllDrafts(true)
    await this.fetchAllInProgress(true)
    await this.fetchAllFinished(true)
  }

  private async created() {
    this.draftFilter.states = [EvaluationStatus.Draft]
    this.inProgressFilter.states = [EvaluationStatus.InProgress]
    this.finishedFilter.states = [EvaluationStatus.Finished]
    this.finishedFilter.sortByFinishedAt = true

    await this.fetchAllDrafts()
    await this.fetchAllInProgress()
    await this.fetchAllFinished()
  }
}
